import React from 'react';
import withIcon from '../utilities/withIcon';

const IconNumber3 = () => {
  return (
    <g>
      <path d="m8 .1819a7.8181 7.8181 0 1 0 7.818 7.8181 7.818 7.818 0 0 0 -7.818-7.8181zm-.1981 11.7692a2.5763 2.5763 0 0 1 -2.7842-1.99l1.2315-.4717a1.49 1.49 0 0 0 1.542 1.3467 1.2383 1.2383 0 0 0 1.3915-1.2434c0-.7588-.5752-1.1728-1.4375-1.1728h-.7832v-1.0245h.7256c.8975 0 1.2881-.4717 1.2881-1.208a1.0614 1.0614 0 0 0 -1.1621-1.0474 1.3524 1.3524 0 0 0 -1.3574 1.2544l-1.208-.4834a2.5238 2.5238 0 0 1 2.6118-1.921c1.5185 0 2.4853.794 2.4853 2.082a1.6881 1.6881 0 0 1 -1.4614 1.7833v.0234a1.7685 1.7685 0 0 1 1.668 1.7949c0 1.4264-1.208 2.2775-2.75 2.2775z" />
    </g>
  );
};

export default withIcon(IconNumber3);
